import _asyncToGenerator from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator";
import createStore from 'ctx-provider';
import { useState, useEffect, useReducer, useRef } from 'react';
import helperWalletEvents from './helpers/wallet-events';
import localStorageProperty from '../localStorageProperty';
import isMobile from '../detectMobile';
import cryptowalletDetection from '../cryptowalletDetection';
import WalletClass from './helpers/wallet-class';
import LedgerWallet from './wallets/ledger';
import BraveWallet from './wallets/brave';
import MetamaskWallet from './wallets/metamask';

var NOOP = function NOOP() {};

var SUPPORTED_WALLETS = ['ledger', 'ledgerbt', 'brave', 'metamask'];
var lsConnectedWallet = localStorageProperty('walletconnectbutton', {
  simpleType: true // we use a boolean

});
var walletClass;
var ledgerClass;
var ledgerBTClass;
var braveClass;
var metamaskClass;
var initialWallet;

var getWalletClass = function getWalletClass(wallet, validChainIds) {
  if (wallet === 'ledger') {
    if (!ledgerClass) {
      ledgerClass = new LedgerWallet(validChainIds);
    }

    return ledgerClass;
  }

  if (wallet === 'ledgerbt') {
    if (!ledgerBTClass) {
      ledgerBTClass = new LedgerWallet(validChainIds, true);
    }

    return ledgerBTClass;
  }

  if (wallet === 'brave') {
    if (!braveClass) {
      braveClass = new BraveWallet(validChainIds);
    }

    return braveClass;
  }

  if (wallet === 'metamask') {
    if (!metamaskClass) {
      metamaskClass = new MetamaskWallet(validChainIds, isMobile);
    }

    return metamaskClass;
  }

  if (!walletClass) {
    walletClass = new WalletClass();
  }

  return walletClass;
};

var getInitialWallet = function getInitialWallet() {
  if (!initialWallet) {
    if (isMobile) {
      if (cryptowalletDetection.isBrave) {
        initialWallet = 'brave';
      } else if (cryptowalletDetection.isMetaMask) {
        initialWallet = 'metamask';
      }
    }

    if (!initialWallet) {
      initialWallet = lsConnectedWallet.get() || '';
    }
  }

  return initialWallet;
}; // hooks always need to be a function:


var useWalletConnection = function useWalletConnection(_ref) {
  var _ref$supportedWallets = _ref.supportedWallets,
      supportedWallets = _ref$supportedWallets === void 0 ? SUPPORTED_WALLETS : _ref$supportedWallets,
      _ref$validChainIds = _ref.validChainIds,
      validChainIds = _ref$validChainIds === void 0 ? [] : _ref$validChainIds;

  var getLib = function getLib(libname) {
    if (libname === 'ledger') {
      return ledgerWallet.current;
    }

    if (libname === 'ledgerbt') {
      return ledgerBTWallet.current;
    }

    if (libname === 'brave') {
      return braveWallet.current;
    }

    if (libname === 'metamask') {
      return metamaskWallet.current;
    }

    return noWallet.current;
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1];

  var _useState3 = useState(getInitialWallet()),
      _useState4 = _slicedToArray(_useState3, 2),
      wallet = _useState4[0],
      setWalletInternal = _useState4[1];

  var noWallet = useRef(getWalletClass('none'));
  var ledgerWallet = useRef(getWalletClass('ledger', validChainIds));
  var ledgerBTWallet = useRef(getWalletClass('ledgerbt', validChainIds));
  var braveWallet = useRef(getWalletClass('brave', validChainIds));
  var metamaskWallet = useRef(getWalletClass('metamask', validChainIds));

  var _useState5 = useState(getLib(wallet)),
      _useState6 = _slicedToArray(_useState5, 2),
      lib = _useState6[0],
      setLib = _useState6[1];

  var libInitializationPromises = useRef({});

  var _useReducer = useReducer(function (x) {
    return x + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      forceUpdate = _useReducer2[1];

  var tryUseWallet = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var connectSuccess;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!lib) {
                _context.next = 13;
                break;
              }

              _context.prev = 1;
              lsConnectedWallet.set(lib.name);
              _context.next = 5;
              return lib.activate();

            case 5:
              connectSuccess = _context.sent;
              forceUpdate();
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              connectSuccess = false;

            case 13:
              if (!connectSuccess) {
                disconnect();
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function tryUseWallet() {
      return _ref2.apply(this, arguments);
    };
  }();

  var disconnect = function disconnect() {
    if (lib) {
      setInitialized(false);
      lib.deactivate();
    }

    setWalletInternal('');
    setLib(getLib(''));
  };

  var defineInitializedLib = function defineInitializedLib(libname) {
    if (libname === lib.name) {
      // is currentlib
      setInitialized(true);
    }
  };

  useEffect(function () {
    lib.onUpdate(forceUpdate);
    var libName = lib.name;

    if (!libInitializationPromises.current[libName]) {
      libInitializationPromises.current[libName] = lib.isInitialized();
    }

    if (libInitializationPromises.current[libName].isPending()) {
      libInitializationPromises.current[libName].then(function () {
        defineInitializedLib(libName);
      });
    } else {
      defineInitializedLib(libName);
    }

    tryUseWallet();
  }, [lib]);

  var setWallet = function setWallet(newWallet) {
    if (supportedWallets.includes(newWallet)) {
      setWalletInternal(newWallet);
      lsConnectedWallet.set(newWallet);

      if (lib && lib.connected) {
        lib.disconnect();
      }

      setLib(getLib(newWallet));
    }
  };
  /*
   * Description of wallet statusses:
   *
   * initialized: first time when all data is read (and the wallet is unlocked while doing so)
   * connected: defines if a wallet is chosen (ledger, brave, metamask etc), but tells nothing about the status of the wallet
   * locked: whether a wallet is locked: metamask and brave can be locked through the extension, ledger will autolock after some time.
   *         a locked wallet cannot read its data
   */


  return {
    initialized: initialized,
    // boolean
    activated: lib.activated,
    // boolean
    wallet: wallet,
    // string
    setWallet: setWallet,
    // function
    hardwareWallet: lib.hardwareWallet,
    // boolean
    bluetooth: !!lib.bluetooth,
    // boolean
    accounts: lib.accounts,
    // [string]
    address: lib.address,
    // string
    chainId: lib.chainId,
    // number
    activate: lib.activate.bind(lib),
    // function
    connected: !!lib && lib.name !== 'no wallet',
    // boolean
    locked: lib.locked,
    // boolean
    networkConnected: lib.networkConnected(),
    disconnect: disconnect,
    // function
    sendTx: lib.sendTx.bind(lib),
    // function
    switchToNetwork: lib.switchToNetwork.bind(lib),
    // function
    hardwareStatus: lib.hardwareStatus,
    // number
    hardwareAddressIndex: lib.getAddressIndex ? lib.getAddressIndex() : -1,
    // attachHardwareDevice: lib.attachDevice ? lib.attachDevice.bind(lib) : NOOP, // function
    readHardwareAccounts: lib.readHardwareAccounts ? lib.readHardwareAccounts.bind(lib) : NOOP,
    // function
    cancelReadHardwareAccounts: lib.cancelReadHardwareAccounts ? lib.cancelReadHardwareAccounts.bind(lib) : NOOP,
    // function
    setSelectHardwareDeviceFn: lib.setSelectDeviceFn ? lib.setSelectDeviceFn.bind(lib) : NOOP,
    // function
    switchToAddress: lib.switchToAddress ? lib.switchToAddress.bind(lib) : NOOP,
    // function
    getHardwareDeviceName: lib.getDeviceName ? lib.getDeviceName.bind(lib) : NOOP,
    // function
    appSelected: lib.appSelected ? lib.appSelected.bind(lib) : NOOP // function

  };
};

var store = createStore(useWalletConnection);
export var walletEvents = helperWalletEvents;
var Provider = store.Provider;
export { Provider };
export default store.ctx;